/** External maps link for Ultrahuman Performance Lab (Bengaluru). */
export const PERFORMANCE_LAB_MAPS_URL =
  'https://maps.app.goo.gl/RLQPoEQZffqtommX8';

/** Google Maps embed (no API key) — centered on Performance Lab. */
export const PERFORMANCE_LAB_MAPS_EMBED_URL =
  'https://www.google.com/maps?q=Ultrahuman+Performance+Lab+Smart+Towers+Domlur+Bengaluru&output=embed';

export const PERFORMANCE_LAB_MAPS_PRECONNECT_ORIGINS = [
  'https://www.google.com',
  'https://maps.google.com',
  'https://maps.googleapis.com',
] as const;
